<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <div class="align-top">
                <v-checkbox
                    class="body-2"
                    :input-value="computedValue"
                    :rules="[
                        !required || requiredField()
                    ]"
                    :aria-label="formattedAriaLabel(
                        metadata[`description${this.upperLocale}`],
                        required
                    )"
                    :data-meta-id="metadata.id"
                    :id="metadata.name"
                    @change="emitValue"
                >
                    <template slot="label">
                        <span>
                            <span>{{ label }}</span>
                        </span>
                    </template>
                </v-checkbox>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { formRules } from '@/mixins/form-rules';
import { mapGetters } from 'vuex';

export default {
    name: 'covid-screening-travelled-outside-quebec',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: '' },
    },

    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        computedValue() {
            return this.value ? 1 : 0;
        },
        label() {
            return this.formattedLabel(
                this.metadata[`description${this.upperLocale}`],
                this.required
            );
        },
        title() {
            return this.metadata['description' + this.upperLocale];
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style scoped>
.border::v-deep {
    border: 2px solid var(--v-border-metadata-color)!important;
    border-radius: 4px!important;
}
</style>
